import React from 'react'
import { Redirect } from 'react-router-dom'
import { TimelineLite, TweenMax } from 'gsap'
import * as Sentry from '@sentry/browser'
import store from './store'

export default {

    convertToSlug (text) {
        return text
            .toLowerCase()
            .replace(/^\/|\/$/g, '')
            .replace(/\//g, '-')
            .replace(/[^\w-]+/g, '')
    },

    animatePageIn (container) {
        TweenMax.fromTo(container, 1, { opacity: 0 }, { opacity: 1 })
    },

    delayedAnimatePageIn (container) {
        setTimeout(() => this.animatePageIn(container), 250)
    },

    noWidows (text) {
        if (text) {
            return text.replace(/\s(?=[^\s]*$)/g, '&nbsp;')
        }
    },

    alphaNumeric (string) {
        return string.replace(/[^a-zA-Z0-9 ]/g, '')
    },

    addDecimals (input, addDollarSign = false) {
        const value = Number(String(input).replace('$', ''))
        const res = String(value).split('.')
        let result = ''

 		if (res.length === 1 || (res.length > 1 && Number(res[1]) <= 0)) {
		    result = String(res[0])
        } else if (res.length > 1 && (Number(res[1]) > 0 || res[1].length > 1)) {
            result = value.toFixed(2)
        } else {
            result = value.toFixed(2)
        }

        return addDollarSign ? `$${result}` : result
    },

    getLastSixMonths () {
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        const today = new Date()
        const months = []

        for (let i = 5; i > -1; i -= 1) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1)
            months.push(monthNames[d.getMonth()].substring(0, 3))
        }

        return months
    },

    handleTabClick (event, btnContainerRef, tabRefArr, tabRef) {
        event.preventDefault()
        btnContainerRef.querySelectorAll('.active').forEach(item => {
            item.classList.remove('active')
        })
        event.currentTarget.classList.add('active')

        const tl = new TimelineLite()
        tl.add(() => {
            tabRefArr.forEach((item, key) => {
                if (tabRef !== tabRefArr[key]) {
                    this.hideTab(tabRefArr[key])
                }
            })
        })
        tl.add(() => {
            this.showTab(tabRef)
        })
    },

    showTab (ref) {
        TweenMax.fromTo(ref, 0.5, { display: 'block', opacity: 0 }, { opacity: 1 })
    },

    hideTab (ref) {
        TweenMax.set(ref, { display: 'none', opacity: 1 })
    },

    pushEvent (name, values = {}) {
        let data = {}

        if (Object.keys(values).length > 0) {
            data = { ...values, event: name }
        } else {
            data = { event: name }
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(data)
    },

    /*
		Replicate a "page view" using hotjars hj() functionality
		Url example: /some/path
	*/
    pushHJEvent (url) {
        if (!url.startsWith('/')) {
            console.error('Hotjar event must begin with a forward slash.')
        } else {
            if (typeof hj === 'function') {
                hj('vpv', url)
            }
        }
    },

    getLocalVar (name, value = '') {
        return (localStorage[name] ? localStorage[name] : value)
    },

    setLocalVar (name, value) {
        localStorage[name] = value
    },

    getSessionVar (name, value = '') {
        return (sessionStorage[name] ? sessionStorage[name] : value)
    },

    setSessionVar (name, value) {
        sessionStorage[name] = value
    },

    setSentryUser () {
        if (store.getState().auth.id) {
            Sentry.configureScope((scope) => {
			    // Token string was cutting off the rest of the data so truncate it
                const authCopy = Object.assign({}, store.getState().auth)
                authCopy.token = authCopy.token ? `${authCopy.token.substring(0, 20)}...` : ''

                scope.setUser({
                    id: store.getState().auth.id,
                    email: store.getState().auth.contactEmail,
                    state: authCopy
                })
            })
        }
    },

    setHotjarUser () {
	    if (store.getState().auth.id && window.hj) {
            window.hj('identify', store.getState().auth.id, {
                id: store.getState().auth.id,
                email: store.getState().auth.contactEmail,
                fullName: store.getState().auth.fullName
            })
        }
    },

    handleError (error, errorInfo) {
        console.error(error, errorInfo)
	    return new Promise(resolve => {
            Sentry.withScope((scope) => {
                scope.setExtras(errorInfo)
                const eventId = Sentry.captureMessage(error)
                resolve(eventId)
            })
        })
    },

    handleException (error, errorInfo) {
        console.error(error, errorInfo)
        return new Promise(resolve => {
            Sentry.withScope((scope) => {
                scope.setExtras(errorInfo)
                const eventId = Sentry.captureException(error)
                resolve(eventId)
            })
        })
    },

    handle404 () {
        return <Redirect push to='/' />
    },
    
    checkNumber (value) {
        const regex = /^[0-9]*$/;
        if (regex.test(value)) return value
        return false
    }

}



// WEBPACK FOOTER //
// ./resources/js/globals.js